let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5hSjH")).then(() => parcelRequire('aqLmU'));